<template>
<div id="homeWrap">

  <!-- Loading Overlay -->
  <div v-if="$parent.loadingIndicator" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;">
    <div style="text-align: center;">
      <div class="ui active inverted loader"></div>
      <p style="color: white; margin-top: 60px; font-size: 16px;">Loading data...</p>
    </div>
  </div>

  <div class="dash-wrap" v-bind:class="{ 'shut': dashboardIsFolded }">
    <div class="dash-bg"></div>

    <Dashboard ref="dashboard" />

    <div id="dashSmallDetails" v-show="!dashboardIsFolded">
      <div data-html="<img src='/static/dninfo.png' style='margin:-3px -5px -19px -5px'/>'"
          data-variation="inverted mini"
          data-position="top left">
        Auto Refresh SentryKit Data: <span style="color:#395;">Always ON</span> <br/>
        Desktop Notifications:
        <span v-if="desktopNotifPerm=='default'" style="color:#395;">Browser Setting</span>
        <span v-if="desktopNotifPerm=='granted'" style="color:#395;">ON</span>
        <span v-if="desktopNotifPerm=='denied'" style="color:#935;">OFF</span>
        <i class="help circle icon"></i>
      </div>
    </div>

    <transition name="fadeDown">
    <NotificationReel v-show="!dashboardIsFolded" v-if="$parent.worldStore.notifications"/>
    </transition>

    <HelpMenu ref="helpMenu" />
    <div style="margin:30px 0px 0px 75px;">
      <div class="ui segment" style="background: none; border: none; -webkit-box-shadow: none;">
        <img src="./assets/skwhite_noslogan.png" style="width: 250px;margin: -15px;">
      </div>

    </div>

    <a class="dash-scroll" href="#" @click.shift.stop.prevent="openHelpModal" @click.prevent="toggleDashboard"><span></span>{{ 'Scroll' | translate }}</a>
  </div>




  <a v-show="dashboardIsFolded"
      style="position:absolute; top:30px; left:50%; margin-left:-90px; z-index:102;"
      class="ui tiny basic circular icon button hideOnMobileSite"
      @click.prevent="toggleDashboard" >
    <i class="angle double up icon"></i>
    <span style="color:#333;">Back to the Home screen</span>
    <div v-if="$parent.worldStore.notifications"
        v-show="$parent.worldStore.notifications.length>0"
        class="floating ui violet mini label"
        data-tooltip="Recent Notifications" data-inverted="" data-position="right center"
        style="border-radius:9px;">{{$parent.worldStore.notifications.length}}</div>
  </a>



  <transition name="fadeDown">
  <div id="detailsSelector" v-show="dashboardIsFolded" class="hideOnMobileSite">

    <div v-if="$parent.onboarding.viewtype"
          class="onboarding ui left pointing large yellow label"
          style="position:absolute; left:475px; z-index: 111;" data-onboarding="viewtype">
      Sort by Products or by Issues - will come really handy!<br/>
      <small style="float:left;margin-top: 5px;">Click on [ISSUES] to dismiss this note</small>
    </div>

    View &nbsp;
    <a @click.prevent="switchToProdView()"
        @click.shift.prevent="setDetailView('pr2')"
        :class="'ui circular big black icon button ' + (detSel=='pr'||detSel=='pr2'?'active':'basic')">
      <i class="cubes icon" ></i> &nbsp; Products
    </a>
    &nbsp;-or- &nbsp;
    <a @click.prevent="setDetailView('wd')"
        @click.shift.prevent="setDetailView('wc')"
        :class="'ui circular big black icon button ' + (detSel=='wd'||detSel=='wc'?'active':'basic')">
      <i class="list layout icon" ></i> &nbsp; Issues
    </a>
    &nbsp;-or- &nbsp;
    <a @click.prevent="setDetailView('inv')"
        :class="'ui circular big black icon button ' + (detSel=='inv'?'active':'basic')"
        style="position:relative;">
      <i class="warehouse icon" ></i> &nbsp; &nbsp; Stock
      <div class="floating ui inverted  red label" style="top:4px; padding: 2px 4px; border-radius:8px;">new</div>
    </a>
    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
    <br>

    <!-- class="'ui circular compact mini olive icon button'"
        style="margin-left:100px;">
      <i class="filter icon" ></i>&nbsp;Show: all
    -->

    <div style="margin-top:8px;margin-left:-10px;">
    <div v-show="filterShowSASelector" class="ui multiple dropdown filtersa" style="padding:0 20px 0 0;">
      <input type="hidden" name="filter">
      <i class="filter icon"></i>
      <span class="text" style="margin-left:0;">Filter S.Accounts</span>
      <div class="menu">
        <div class="header" style="margin:3px;">
          Seller Accounts
        </div>
        <div class="scrolling menu">
          <div v-for="sa in $parent.worldStore.sellerAccounts"
                class="item"
                :data-value="sa.sellerId">
            <i :class="(sa.region=='NA'?'olive':'teal')+' circle compact icon'"></i>{{sa.accountNickName}}
          </div>
        </div>
      </div>
    </div>

    <div v-show="filterUserCountries.length>1" class="ui multiple dropdown filterc" style="padding:0">
      <input type="hidden" name="filter">
      <i class="filter icon"></i>
      <span class="text" style="margin-left:0;">Filter Marketplaces</span>
      <div class="menu">
        <div class="header" style="margin:3px;">
          Marketplaces
        </div>
        <div class="scrolling menu">
          <div v-for="c in filteredCountries"
                :class="c=='s' ? 'divider' : 'item'"
                :data-value="c">
            <i v-if="c!='s'" :class="c.toLowerCase().replace('uk','gb')+' flag'"></i>{{c!='s' ? c : ''}}
          </div>
        </div>
      </div>
    </div>
    </div>


    <div class="ui checkbox labelCursorFix" :style="'display:none;    margin-left:180px; margin-top:10px;' + (detSel==='pr' ? 'opacity:0;' : '')">
      <input type="checkbox" data-lpignore="true" v-model="sortListByImportance" name="sortListByImportance" id="sortListByImportance">
      <label class="labelCursorFix" for="sortListByImportance">Show Problems on top</label>
    </div>



    <div style="position:absolute; top:55px; left:46%; transform:translateX(41vw); width:100px;height:40px;" v-if="detSel=='pr'||detSel=='pr2'">
    <i class="big icon th  " :style="'cursor:pointer; color:'+(detSel=='pr' ?'yellow;':'#eee')" @click.prevent="setDetailView('pr')"></i>
    <i class="big icon bars" :style="'cursor:pointer; color:'+(detSel=='pr2'?'yellow;':'#eee')" @click.prevent="setDetailView('pr2')"></i>
    </div>




  </div>
  </transition>



  <!-- MAIN CONTENT -->


  <div id="mainContainer" :class="{opn: dashboardIsFolded}">

    <!-- mobile specific messages -->
    <div class="ui inverted black segment onlyOnMobileSite" style="margin-bottom:20px; margin-left:10px; width:140px; z-index: 101;">
      <strong><span style="color:#f2711c;">Sentry</span><span style="color:#3bd;">Kit</span> <span style="">Mobile</span></strong> <small></small>
    </div>

    <div v-if="detSel=='wd'||detSel=='wc'"
      class="ui blue message onlyOnMobileSite"
      @click.prevent="setDetailView('pr')"
      style="cursor:pointer; margin:20px;">
      On SentryKit Mobile only the <strong>Product&nbsp;View</strong> is available.<br/><br/>
      Tap this message to switch to that.
    </div>

     <div v-if="$root.paymentStatus==402||$root.paymentStatus==403"
      class="ui red message onlyOnMobileSite"
      style="margin:20px;">
      Your SentryKit account is unfortunately suspended. We couldn't charge you for the current month.<br/><br/>
      Please update your payment method in <router-link to="/settings">Account Settings</router-link>.
    </div>
    <!-- end: mobile specific messages -->



    <!-- PRODUCT VIEW -->
    <div id="prodCont" key="2" v-if="detSel=='pr'||detSel=='pr2'" class="ui fluid container" style="padding:0 4vh;">
      <transition name="fadeLeft" mode="out-in" appear>
        <ProductCard v-if="detSel=='pr'" ref="productCard"/>
        <ProductList v-if="detSel=='pr2'" ref="productList"/>
      </transition>

      <!-- Pagination Controls for Products - Outside transition -->
      <div v-if="detSel=='pr'||detSel=='pr2'" class="ui center aligned segment" style="margin-top: 20px; background-color: #f8f8f8; border: 1px solid #ddd;">
        <div class="ui pagination menu">
          <a class="item" :class="{ disabled: getCurrentPage() === 0 }" @click="prevPage()">
            <i class="left chevron icon"></i>
          </a>

          <!-- Page numbers -->
          <a v-for="page in Math.min(5, getTotalPages())" :key="page"
             class="item"
             :class="{ active: getCurrentPage() === getPageNumber(page) }"
             @click="goToPage(getPageNumber(page))">
            {{ getPageNumber(page) + 1 }}
          </a>

          <a class="item" :class="{ disabled: getCurrentPage() >= (getTotalPages() - 1) }" @click="nextPage()">
            <i class="right chevron icon"></i>
          </a>
        </div>

        <div class="ui small message" style="margin-top: 10px;">
          Showing page {{ getCurrentPage() + 1 }} of {{ getTotalPages() }}
          ({{ getTotalItems() }} total products)
        </div>
      </div>
    </div>

    <!-- INVENTORY VIEW -->
    <div id="prodCont" key="3" v-if="detSel=='inv'" class="ui fluid container" style="padding:0 7vw;">
      <transition name="fadeLeft" mode="out-in" appear>

      <div style="overflow: auto;">
        <!-- <div class="ui message">
         onboarding message
        </div> -->

        <InventoryList/>

        <!-- Stocks Pagination Controls -->
        <div v-if="$parent.stocksTotalPages > 1" class="ui center aligned segment" style="margin-top: 20px;">
          <div class="ui pagination menu">
            <a class="item" :class="{ disabled: $parent.stocksCurrentPage === 0 }" @click="prevStocksPage">
              <i class="left chevron icon"></i>
            </a>

            <!-- Page numbers -->
            <a v-for="page in Math.min(5, $parent.stocksTotalPages)" :key="page"
               class="item"
               :class="{ active: $parent.stocksCurrentPage === getPageNumber(page) }"
               @click="loadStocksPage(getPageNumber(page))">
              {{ getPageNumber(page) + 1 }}
            </a>

            <a class="item" :class="{ disabled: $parent.stocksCurrentPage >= $parent.stocksTotalPages - 1 }" @click="nextStocksPage">
              <i class="right chevron icon"></i>
            </a>
          </div>

          <div class="ui small message" style="margin-top: 10px;">
            Showing page {{ $parent.stocksCurrentPage + 1 }} of {{ $parent.stocksTotalPages }}
            ({{ $parent.stocksTotalItems }} total items)
          </div>
        </div>

<!--        <PartnerBanner v-if="showPartnerCards" v-on:dismiss="showPartnerCards = false" is-footer="true" />-->

      </div>

      </transition>
    </div>


    <!-- ISSUES VIEW -->
    <div id='wdCont' :class="detSel=='wd'?'wide':''" key="1" v-if="detSel=='wd'||detSel=='wc'" >
      <!-- menu -->
      <transition name="componentFade" appear>
        <WatchdogMenu :wdNewErrorCounts="wdNewErrorCounts" :wdMenuUpdateTrigger="wdMenuUpdateTrigger"/>
      </transition>
      <!-- /menu -->

      <!--transition name="fadeLeft" appear-->
      <div class='ui stackable cards hideOnMobileSite' id="context">
        <Watchdog
          v-for='i,index in wdListSorted'
          :wdtype="i"
          :wd="$parent.worldStore.watchDogs[i]"
          :detSel="detSel"
          :key="i"
          :scrollIntoView="true"
          :nth="index"
          :suppressed-watchdogs="suppressedWatchdogs"/>
      </div>
      <!--/transition-->
    </div>


    <div v-if="detSel=='wd'||detSel=='wc'" id="darkbackgr" style="position:fixed; top:0; height:100vh; width:100vw; background-color:rgba(0,0,0,.6); pointer-events:none; z-index:11; display:none;"></div>
  </div>


  <ProductDetails ref="productDetails"/>

  <LoadingSpinner v-bind:class="{ 'side': dashboardIsFolded }" />

  <Footer />

</div>
</template>

<script>
import { MARKETPLACE_FILTER_COUNTRIES_ALL, buildMarketplaceFilterDropdownItems } from './utils/sellerAccountsFromV1Api.js'
import $ from 'jquery'
import Watchdog from './components/Watchdog'
import WatchdogMenu from './components/WatchdogMenu'
import ProductCard from './components/ProductCard'
import ProductList from './components/ProductList'
import InventoryList from './components/InventoryList'
import ProductDetails from './components/ProductDetails'
import Dashboard from './components/Dashboard'
import NotificationReel from './components/NotificationReel'
import Footer from './components/Footer'
import LoadingSpinner from './components/LoadingSpinner'
import HelpMenu from './components/HelpMenu'
import PartnerBanner from './components/PartnerBanner'
export default {
  name: 'home',
  components: {
    Watchdog,
    WatchdogMenu,
    Dashboard,
    HelpMenu,
    NotificationReel,
    ProductCard,
    ProductList,
    InventoryList,
    ProductDetails,
    Footer,
    LoadingSpinner,
    PartnerBanner,
  },
  data: function () {
    let desktopNotifPerm = null
    if ('Notification' in window) desktopNotifPerm = Notification.permission
    const urlParams = new URLSearchParams(window.location.search)
    const viewParam = urlParams.get('view')
    let initialDetSel = 'pr'
    const shouldFoldDashboard = viewParam !== null
    if (viewParam === 'products') {
      initialDetSel = 'pr'
    } else if (viewParam === 'issues') {
      initialDetSel = 'wd'
    } else if (viewParam === 'stock') {
      initialDetSel = 'inv'
    } else {
      initialDetSel = localStorage.getItem('detailViewSelector') === null ? 'pr' : localStorage.getItem('detailViewSelector')
    }
    return {
      dashboardIsFolded: shouldFoldDashboard,
      dashboardIsAnimating: false,
      blockScrolling: false,
      // blockDashboardReopen: false,
      // scrolledFarFromTop: false,
      firstEverHere: false,
      detSel: initialDetSel,
      sortListByImportance: true,
      galleryIndexForPopup: 0,
      galleryArrayIdForPopup: [],
      desktopNotifPerm: desktopNotifPerm,
      wdListSorted: [],
      wdNewErrorCounts: {},
      wdMenuUpdateTrigger: '',
      // TODO: move filter to a component
      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: MARKETPLACE_FILTER_COUNTRIES_ALL,
      filterUserCountries: [],
      filterShowSASelector: false,
      productViewPreference: 'pr',
      lastDismissDate: localStorage.getItem('lastDismissDate'),
      suppressedWatchdogs: []
    }
  },
  methods: {
    setDetailView: function (val) {
      this.detSel = val
      localStorage.setItem('detailViewSelector', val)
      this.$parent.onboarder('viewtype')

      if (val === 'pr' || val === 'pr2') {
        this.productViewPreference = val
        this.loadProductsList()
      }
      if (val === 'wd' || val === 'wc') {
        this.loadWatchdogsData()
        this.fetchSuppressedWatchdogs()
      }
      if (val === 'inv') {
        this.loadStockData()
      }
    },
    loadDashboardStats: function () {
      console.log('[HomePage] loadDashboardStats called, $parent.dashboardStats exists:', !!this.$parent.dashboardStats)
      if (this.$parent.dashboardStats) {
        this.$parent.dashboardStats()
      } else {
        console.error('[HomePage] dashboardStats method not found on $parent, retrying in 1 second...')
        // Retry after a short delay in case of timing issues
        setTimeout(() => {
          if (this.$parent.dashboardStats) {
            console.log('[HomePage] Retry successful, calling dashboardStats')
            this.$parent.dashboardStats()
          } else {
            console.error('[HomePage] Retry failed, dashboardStats still not found')
          }
        }, 1000)
      }
    },
    loadProductsList: function () {
      if (this.$parent.productsList) {
        var marketplaces = this.filterByMarket.length ? this.filterByMarket.join(',') : null
        var sellerAccounts = this.filterBySellAcc.length ? this.filterBySellAcc.join(',') : null
        this.$parent.productsList(marketplaces, sellerAccounts)
      }
    },
    loadWatchdogsData: function () {
      if (this.$parent.watchdogsData) {
        this.$parent.watchdogsData()
      }
    },
    loadStockData: function () {
      if (this.$parent.stockData) {
        // Reset to page 0 when loading stock data
        this.$parent.stocksCurrentPage = 0
        this.$parent.stockData(0, this.$parent.stocksPageSize)
      }
    },
    productDetails: function (productId) {
      // COMMENTED OUT: stateoftheworld API call
      return Promise.resolve({ body: {} })
      /* try {
        return this.$http.get('/api/sentinel/stateoftheworld', {
          params: { productDetails: productId }
        }).then((response) => {
          console.log('[HomePage] productDetails API response:', response.body)
          try {
            if (typeof response.body === 'string' || response.body instanceof String) return

            // Update product data directly
            if (response.body.product) {
              console.log('[HomePage] Updating product data for:', productId, response.body.product)
              this.$set(this.$parent.worldStore.products, productId, response.body.product)
            }
            if (response.body.watchDogs) {
              console.log('[HomePage] Updating watchDogs data for:', productId, response.body.watchDogs)
              // Store watchDogs in FLAT structure - exactly as received from API
              for (const [key, watchDogItem] of Object.entries(response.body.watchDogs)) {
                this.$set(this.$parent.worldStore.watchDogs, key, watchDogItem)
              }
            }

            // Force Vue to re-render the ProductDetails component
            this.$nextTick(() => {
              this.$forceUpdate()
            })

            return response.body
          } catch (error) {
            window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A')
            return Promise.reject(error)
          }
        }, (response) => {
          return Promise.reject(response)
        })
      } catch (error) {
        window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A')
        return Promise.reject(error)
      } */
    },
    switchToProdView: function () { this.setDetailView(this.productViewPreference) },
    toggleDashboard: function () {
      this.dashboardIsFolded = !this.dashboardIsFolded
      // this.blockDashboardReopen = true
      // this.scrolledFarFromTop = false
      this.dashboardIsAnimating = true
      setTimeout(() => { this.dashboardIsAnimating = false }, 1100)
      setTimeout(() => { this.blockScrolling = false }, 600)
      if (!this.dashboardIsFolded) {
        // Load dashboard stats when dashboard is opened
        this.loadDashboardStats()
      }
    },
    dvlprmd: function () { $('.stts21kdfslds').removeClass('stts21kdfslds') },
    onScroll: function (e) {
      if (this.$refs.helpMenu && !this.$refs.helpMenu.isModalOpen && !this.dashboardIsFolded) {
        e.preventDefault()
        this.toggleDashboard()
        this.blockScrolling = true
      }
      if (this.blockScrolling === true) {
        e.preventDefault()
        return false
      }

      /*
      // if the user didnt scroll at least 10 pixes block reopen (annoying if not)
      if (window.scrollY > 10) this.blockDashboardReopen = false
      // but also, if the user scrolled more than a 100px (started reading the contect below)
      //  block autotoggling and show open dashboard button
      if (window.scrollY > 150) {
        this.scrolledFarFromTop = true // show button + block dashboard open on scrollTop
      }
      if (this.dashboardIsFolded && !this.blockDashboardReopen && !this.scrolledFarFromTop && window.scrollY < 2) {
        this.dashboardIsFolded = false
        this.scrolledFarFromTop = false
      }
      // user scrolled back to top, reset scrolledFarFromTop, but tdont open dashboard
      // if (window.scrollY < 2 && !this.blockDashboardReopen) this.scrolledFarFromTop = false
      // return false
      */
    },
    openHelpModal: function (i) {
      this.$refs.helpMenu.openHelpModal(i)
    },
    openProductDetailModal: function (galleryArray, galleryIndex) {
      console.log('[HomePage] openProductDetailModal called with:', galleryArray, galleryIndex)
      // Load detailed product data for the CLICKED product (at galleryIndex)
      if (galleryArray && galleryArray.length > 0 && galleryIndex >= 0) {
        const productId = galleryArray[galleryIndex]  // FIX: Use the actual clicked product
        console.log('[HomePage] productDetails method exists:', !!this.productDetails)
        if (this.productDetails) {
          console.log('[HomePage] Calling productDetails for productId:', productId)
          const result = this.productDetails(productId)
          console.log('[HomePage] productDetails returned:', result, 'type:', typeof result)
          if (result && typeof result.then === 'function') {
            result.then(() => {
              console.log('[HomePage] Product details loaded, opening modal')
              // Wait for product data to be loaded before opening modal
              this.$refs.productDetails.setGalleryParams(galleryIndex, galleryArray)
              $('#productDetailModal').modal({
                dimmerSettings: {opacity: 0.9},
                onHidden: function () {
                  if ('pushState' in history) {
                    history.pushState('', document.title, window.location.pathname + window.location.search)
                  }
                  $('.ui.dimmer.modals').css('background-color', '')
                }
              }).modal('show')
            }).catch((error) => {
              console.error('[HomePage] Product details API failed:', error)
              // If API call fails, still open modal but with limited data
              this.$refs.productDetails.setGalleryParams(galleryIndex, galleryArray)
              $('#productDetailModal').modal({
                dimmerSettings: {opacity: 0.9},
                onHidden: function () {
                  if ('pushState' in history) {
                    history.pushState('', document.title, window.location.pathname + window.location.search)
                  }
                  $('.ui.dimmer.modals').css('background-color', '')
                }
              }).modal('show')
            })
          } else {
            console.error('[HomePage] productDetails did not return a Promise!')
          }
        } else {
          console.error('[HomePage] productDetails method not found!')
          // Fallback if productDetails method doesn't exist
          this.$refs.productDetails.setGalleryParams(galleryIndex, galleryArray)
          $('#productDetailModal').modal({
            dimmerSettings: {opacity: 0.9},
            onHidden: function () {
              if ('pushState' in history) {
                history.pushState('', document.title, window.location.pathname + window.location.search)
              }
              $('.ui.dimmer.modals').css('background-color', '')
            }
          }).modal('show')
        }
      }
    },
    utilWaitFor: function (test, onSuccess, timeOut, startCount, maxCount) {
      // Check if test is true. If not, re-check in timeOut, maxCount times.
      if (test()) onSuccess()
      else {
        if (startCount++ < maxCount) setTimeout(() => this.utilWaitFor(test, onSuccess, timeOut, startCount, maxCount), timeOut)
      }
    },
    calcWdListSorted: function () {
      // TODO: watchdogs also have to do a similar sorting, eliminate code repeatition
      if (!this.sortListByImportance) return this.$parent.wdList

      const hasAlert = []
      const noAlert = []
      const wd = this.$parent.worldStore.watchDogs

      for (let i = 0; i < this.$parent.wdList.length; i++) {
        const wdName = this.$parent.wdList[i]
        const alertCount = Object.values(wd[wdName].items).filter((item) => item.issueStatus === 0 && !item.muted && (item.status === 1 || item.status === 2)).length
        const list = alertCount > 0 ? hasAlert : noAlert
        list.push(this.$parent.wdList[i])
      }
      return hasAlert.concat(noAlert)
    },
    updateFilters: function () {
      this.filterUserCountries = Array.from(new Set(Object.values(this.$parent.worldStore.products).map((i) => i.marketplace)))
      this.filterShowSASelector = (Object.keys(this.$parent.worldStore.sellerAccounts).length > 1)
    },
    fetchSuppressedWatchdogs () {
      this.$http.get('/api/operations/tenant-features/suppressed-alerts')
        .then((response) => {
          console.log('[HomePage] Suppressed watchdogs API response:', response.body)
          this.suppressedWatchdogs = response.body.map(x => x.toUpperCase())
        })
    },
    // Stocks pagination methods
    loadStocksPage: function (page) {
      if (this.$parent.loadStocksPage) {
        this.$parent.loadStocksPage(page)
      }
    },
    nextStocksPage: function () {
      if (this.$parent.nextStocksPage) {
        this.$parent.nextStocksPage()
      }
    },
    prevStocksPage: function () {
      if (this.$parent.prevStocksPage) {
        this.$parent.prevStocksPage()
      }
    },
    getPageNumber: function (index) {
      // Calculate page number based on current page and index
      const currentPage = this.$parent.stocksCurrentPage || 0
      const totalPages = this.$parent.stocksTotalPages || 1

      // Show pages around current page
      if (totalPages <= 5) {
        return index - 1
      }

      // Show 5 pages centered around current page
      const startPage = Math.max(0, currentPage - 2)
      const endPage = Math.min(totalPages - 1, startPage + 4)
      const adjustedStartPage = Math.max(0, endPage - 4)

      return adjustedStartPage + index - 1
    },
    // Product pagination helper methods
    getCurrentPage: function () {
      const component = this.$refs.productCard || this.$refs.productList
      return component ? component.currentPage : 0
    },
    getTotalPages: function () {
      const component = this.$refs.productCard || this.$refs.productList
      return component ? component.totalPages : 1
    },
    getTotalItems: function () {
      const component = this.$refs.productCard || this.$refs.productList
      return component ? component.totalItems : 0
    },
    prevPage: function () {
      const component = this.$refs.productCard || this.$refs.productList
      if (component) component.prevPage()
    },
    nextPage: function () {
      const component = this.$refs.productCard || this.$refs.productList
      if (component) component.nextPage()
    },
    goToPage: function (page) {
      const component = this.$refs.productCard || this.$refs.productList
      if (component) component.goToPage(page)
    },
  },
  computed: {
    filteredCountries: function () {
      return buildMarketplaceFilterDropdownItems(this.filterUserCountries, this.filterCountriesAll)
    },
    showPartnerCards: {
      get: function () {
        let sevenDaysInSeconds = 3600 * 24 * 7
        sevenDaysInSeconds = 20

        return this.$root.secondsSinceFirstSellerAccountCreated > sevenDaysInSeconds &&
          (this.lastDismissDate == null || (new Date() - this.lastDismissDate) / 1000 > sevenDaysInSeconds)
      },
      set: function () {
        this.lastDismissDate = new Date().getTime()
      },
    }
  },
  created: function () {
    this.fetchSuppressedWatchdogs()
    this.wdListSorted = this.calcWdListSorted()
  },
  mounted: function (e) {
    window.scrollTo(0, 0)
    $(document).on('scroll wheel mousewheel keyup touchmove', this.onScroll)
    
    if (this.$route.query.view) {
      const view = this.$route.query.view
      this.dashboardIsFolded = true
      this.dashboardIsAnimating = true
      setTimeout(() => { this.dashboardIsAnimating = false }, 1100)
      
      if (view === 'products') {
        this.setDetailView('pr')
      } else if (view === 'issues') {
        this.setDetailView('wd')
      } else if (view === 'stock') {
        this.setDetailView('inv')
      }
    } else {
      if (this.detSel === 'pr' || this.detSel === 'pr2') {
        this.loadProductsList()
      } else if (this.detSel === 'wd' || this.detSel === 'wc') {
        this.loadWatchdogsData()
        this.fetchSuppressedWatchdogs()
      } else if (this.detSel === 'inv') {
        this.loadStockData()
      }
    }

    // TODO: check if these are needed / still
    if (!this.$root.anySellerAccountSetupCompleted) {
      this.firstEverHere = true
      this.$root.anySellerAccountSetupCompleted = true
    }

    $(this.$el).find('#dashSmallDetails div').popup({ delay: { show: 300, hide: 0 }, transition: 'fade' })

    // hash-deeplink: open product details
    if (this.$root.deeplink.indexOf('pdet-') > -1) {
      const pid = this.$root.deeplink.substr(this.$root.deeplink.indexOf('pdet-') + 5)
      this.utilWaitFor(
        () => this.$parent.worldStore.products.hasOwnProperty(pid),
        () => this.openProductDetailModal([ pid ], 0),
        250, // recheck in 250 msec
        0,
        180  // 45 sec wait max
      )
    }
    // this is needed when coming from settings...
    this.wdMenuUpdateTrigger = 'something'

    // FILTER: init filter and dropdowns
    this.updateFilters()
    $('#detailsSelector .ui.dropdown.filterc').dropdown({
      onChange: (v) => {
        if (v === '') this.filterByMarket = []
        else this.filterByMarket = v.split(',')
        if (this.detSel === 'pr' || this.detSel === 'pr2') this.loadProductsList()
      }
    })
    $('#detailsSelector .ui.dropdown.filtersa').dropdown({
      onChange: (v) => {
        if (v === '') this.filterBySellAcc = []
        else this.filterBySellAcc = v.split(',').map(Number)
        if (this.detSel === 'pr' || this.detSel === 'pr2') this.loadProductsList()
      }
    })

    // Initial data load based on selected view
    if (this.detSel === 'pr' || this.detSel === 'pr2') {
      this.loadProductsList()
    } else if (this.detSel === 'wd' || this.detSel === 'wc') {
      this.loadWatchdogsData()
    } else if (this.detSel === 'inv') {
      this.loadStockData()
    }

    // Load dashboard stats on initial page load since dashboard starts open
    this.loadDashboardStats()
  },
  destroyed: function () {
    $(document).off('scroll wheel mousewheel keyup touchmove', this.onScroll)
  },
  watch: {
    '$route.query.view': function (newView) {
      if (newView) {
        if (newView === 'products') {
          this.setDetailView('pr')
        } else if (newView === 'issues') {
          this.setDetailView('wd')
        } else if (newView === 'stock') {
          this.setDetailView('inv')
        }
      }
    },
    '$parent.worldStore': function () {
      this.wdListSorted = this.calcWdListSorted()

      // Get the list of marketplaces from SOTW
      this.updateFilters()

      // Load dashboard stats when worldStore changes (e.g., user switch)
      this.loadDashboardStats()
    },
    sortListByImportance: function () {
      this.wdListSorted = this.calcWdListSorted()
    },
    lastDismissDate: function (value) {
      localStorage.setItem('lastDismissDate', value)
    }
  },
}

</script>

<style>
#detailsSelector {position:absolute; width:700px; margin-left:-350px; top: calc(70px + 2vh); left:50%; text-align: center; z-index:100;}
#detailsSelector .ui.multiple.dropdown .label {padding:4px 5px; background:#fff;}
#detailsSelector .ui.multiple.dropdown .menu>.item {padding:8px 18px !important;}
#detailsSelector .ui.multiple.dropdown .menu>.divider {margin: 2px 0;}
#detailsSelector .ui.multiple.dropdown .flag {margin-right:2px;}

#detailsSelector .ui.checkbox {opacity:0; transition:all .5s;}
#detailsSelector:hover .ui.checkbox {opacity:.8;}

.dash-wrap {
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  min-height: 660px;
  margin-bottom: 4px;
  transition-duration: 0.5s;
  perspective: 1000px;
}
.dash-bg {
	position: absolute;
	overflow: hidden;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	backface-visibility: hidden;
	transition-property: transform;
	transition-duration: 0.5s;
  background-image: linear-gradient(to bottom, rgb(0,55,128), rgb(0,113,178));
}
.dash-bg img {
	position: absolute;
	top: 0;
	left: 0;
	display: block;
	width: 100%;
	min-height: 100%;
}
.dash-bg::after {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	opacity: 0;
	pointer-events: none;
	background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(241,241,241,1) 100%);
	transition-property: opacity;
	transition-duration: 0.5s;
}
.dash-wrap.shut .dash-bg::after {
	opacity: 1;
}
.dash-wrap.shut .dash-bg {
	transform: translateY(-25%);
}

.dash-wrap.shut .dash-cont{
  opacity: 0;
  transform: translateY(-130%) rotateX(25deg) scale(1.5);
}
#mainContainer {
  position: relative;
  margin-top: calc(150px + 5vh);
  margin-bottom: 8vmax;
  transform: translateY(100vh);
  transition-property: transform;
  transition-duration: 0.6s;
}
#mainContainer.opn { transform: none; }

a.dash-scroll {position: fixed; bottom:10vh; padding-top: 60px; left: 48%; z-index: 2; display: inline-block; color: #fff; letter-spacing: .1em; text-decoration: none; transition: opacity .5s;}
a.dash-scroll:hover {opacity:.5; color:orange;}
a.dash-scroll span {position: absolute; top: 10px; left: 50%; width: 46px; height: 46px; margin-left: -23px; border: 3px solid #fff; border-radius: 100%; box-sizing: border-box;}
a.dash-scroll span::after {position: absolute; top: 50%; left: 50%; content: ''; width: 16px; height: 16px; margin: -12px 0 0 -8px; border-left: 3px solid #fff; border-bottom: 3px solid #fff; transform: rotate(-45deg); box-sizing: border-box;}
.dash-wrap.shut a.dash-scroll {display: none;}

#homeWrap {background:rgba(241,241,241,1);}

#wdCont {
  position: relative;
  min-height: 100vh;
  transition: padding 0.5s; transition-delay: 0.5s;
/*  b-ackground: radial-gradient(ellipse at center, rgba(215,215,215,.7) 0%, rgba(0,0,0,0) 70%),
              linear-gradient(to bottom, rgba(215,215,215,0) 60%, rgba(115,115,115,1) 100%);  */
}

#prodCont {
  position: relative;

  min-height: 100vh;
}

#dashSmallDetails {
  position: absolute;
  bottom: 5px;
  left: 10px;
  width: 240px;
  height: 50px;
  z-index: 3;
  color: #aaa;
  font-size: 12px;
  background-color: rgba(0, 0, 0, .5);
  padding: 7px;
  border-radius: 4px;
  margin-bottom: 1em
}

#app .onlyOnMobileSite {display:none !important;}
@media only screen and (max-width: 749px) {
  #app .onlyOnMobileSite {display:block !important;}
  #app .hideOnMobileSite {display:none !important;}

  .dash-wrap {display:none !important;}
  #mainContainer {transform: none !important; top: 0px;}
  #app .ui.secondary.inverted.menu {background-color:#111;}
  #app #prodCont .card:hover  {transform: none;}
  #app .ui.stacked.segment {padding-bottom: 1.4em !important;}
  #app .ui.container {margin-left: 1.2em!important;}
  #productDetailModal .prodDetOverlayHeader {height:auto;}

  .onboarding {display:none !important;}
}

#app .ui.rail { width: 160px; }
</style>



// WEBPACK FOOTER //
// HomePage.vue?746173ce